export default {"src":"/_next/static/media/langchain.2852fd57.svg","height":160,"width":320};